import React from 'react';
import PropTypes from 'prop-types';
import { List, Set, Map } from 'immutable';

import ImmutablePropTypes from 'react-immutable-proptypes';
import ConstraintsForm from './ConstraintsEditForm.jsx';
import { throttle } from 'lodash';

import Icon from '../Icon/Icon';

function mapGrants(grants) {
    if (!grants) {
        return Map();
    }

    let grantsMap = {};

    grants.forEach(g => {
        grantsMap[g.get('permission')] = g.get('constraints');
    });

    return Map(grantsMap);
}

function hasContextAttributes(permission) {
    return permission.get('contextAttributes').size > 0;
}

class PermissionsList extends React.Component {
    static propTypes = {
        onPermissionsChange: PropTypes.func,
        onRoleChange: PropTypes.func,

        permissions: ImmutablePropTypes.map.isRequired,
        role: ImmutablePropTypes.map,
        grants: ImmutablePropTypes.list,

        disabled: PropTypes.bool
    };

    static defaultProps = {
        onRoleChange: () => {},
        disabled: false
    };

    constructor(props) {
        super(props);
        this.state = {
            grants: mapGrants(props.grants)
        };

        this._onChange = throttle(this.onChange, 300);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.props.grants !== props.grants) {
            this.setState({
                grants: mapGrants(props.grants)
            });
        }
    }

    findGrant(permission) {
        return this.state.grants && this.state.grants.get(permission);
    }

    onGrantChange(permission, checked) {
        let { grants } = this.state;

        if (checked) {
            grants = grants.set(permission, List());
        } else {
            grants = grants.delete(permission);
        }

        this.setState({
            grants
        });

        this._onChange(grants);
    }

    onConstraintChange(permission, constraints) {
        let { grants } = this.state;

        this.setState({
            grants: grants.set(permission, constraints)
        });

        this._onChange(grants);
    }

    onPermissionSelected(id) {
        if (this.state.selectedPermission === id) {
            this.setState({
                selectedPermission: null
            });
        } else {
            this.setState({
                selectedPermission: id
            });
        }
    }

    onChange(grants) {
        this.props.onRoleChange(
            grants.map((constraints, permission) => ({ constraints: constraints.toJS(), permission })).toArray()
        );
    }

    shouldShowConstraintsForm(permission) {
        const { selectedPermission } = this.state;
        return (
            selectedPermission === permission.get('id') &&
            hasContextAttributes(permission)
        );
    }

    render() {
        let { permissions, disabled } = this.props;

        permissions = permissions.sortBy(p => p.get('name'));

        return (
            <div className="permissions">
                <ul className="permissions-list">
                    {
                        permissions.map(
                            p => (
                                <li key={ p.get('id') }>
                                    <div className="permissions-list__permission">
                                        <input
                                            checked={ !!this.findGrant(p.get('id')) }
                                            onChange={
                                                e => this.onGrantChange(p.get('id'), e.target.checked)
                                            }
                                            type="checkbox"
                                            disabled={ disabled }
                                        />

                                        { p.get('name') }


                                        {
                                            hasContextAttributes(p) && !disabled ? (
                                                <button
                                                    type="button"
                                                    className="btn"
                                                    onClick={ () => this.onPermissionSelected(p.get('id')) }
                                                >
                                                    <Icon name="cog" />
                                                </button>
                                            ) : void 0
                                        }
                                    </div>

                                    {
                                        this.shouldShowConstraintsForm(p) ? (
                                            <ConstraintsForm
                                                onChange={ data => this.onConstraintChange(p.get('id'), data) }
                                                permission={ p }
                                                grant={ this.findGrant(p.get('id')) }
                                                disabled={ disabled }
                                            />
                                        ) : void 0
                                    }
                                </li>
                            )
                        )
                    }
                </ul>
            </div>
        );
    }
}

export default PermissionsList;
